import React, {useCallback, useEffect, useState} from 'react';
import http, {useHttp} from "../services/HttpService";
import {
    getDigiWabPageEndpointByNr,
    getDownloadPDFEndpoint
} from "../services/BescheidsService";
import CircularProgress from "@material-ui/core/CircularProgress";
import {wasserbuchStyle} from "../styles/WasserbuchStyle";
import {useLocation} from "react-router-dom";

export default function WasserbuchView() {
    const location = useLocation();

    const [anlageId, setAnlageId] = useState("");
    const [page, refetchPage] = useHttp(getDigiWabPageEndpointByNr(anlageId), {manual: true});
    const [initialized, setInitialized] = useState(false);
    const [currentDokId, setCurrentDokId] = useState("");

    const handleUrlParameters = useCallback(() => {
        const searchParams = new URLSearchParams(location.search);
        const wbbId = searchParams.get('wbbId');
        const dokId = searchParams.get('dokId');

        if (wbbId) {
            setAnlageId(wbbId);
            refetchPage();
        }

        if (dokId) {
            if (currentDokId !== dokId) {
                let path = location.pathname;
                let pathArray = path.split("/wbb");
                const calcedId = pathArray[pathArray.length - 1];
                downloadPDF(calcedId, dokId);
                setCurrentDokId(dokId);
            }
        }
    }, [location.search, currentDokId, refetchPage, location.pathname]);

    if (!initialized) {
        handleUrlParameters();
        setInitialized(true);
    }

    useEffect(() => {
        handleUrlParameters();
    }, [location.search, handleUrlParameters]);

    function downloadPDF(entryId, dokId) {
        http.get(getDownloadPDFEndpoint(entryId, dokId), { responseType: 'arraybuffer' })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'download.pdf';
                a.click();
            })
            .catch(error => console.error('Error:', error));
    }

    if (page.loading) {
        return (
            <div style={{height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                <CircularProgress/>
            </div>
        );
    }


    let html = page.data;
    if (html) {
        const splittedHtml = html.split("</head>")
        html = wasserbuchStyle + splittedHtml[1];
    }

    return (
        <div className={"digiwab_background"}>
            <div className={"viewScrollContainer"} style={{height: "100%"}}>
                <div style={{margin: "var(--tabsheet-content-top-spacing) var(--horizontal-spacing) var(--vertical-spacing)"}}>
                    <div className="content" dangerouslySetInnerHTML={{__html: html}}/>
                </div>
            </div>
        </div>
    );
}
